<div class="pagamentos-eletronicos">
  <header class="pe-page-header">
    <div class="pe-title-group">
      <span class="pe-title-icon"><i class="fas fa-credit-card"></i></span>
      <div>
        <h4>Pagamentos Eletrônicos</h4>
        <p>ConnectTEF · cobranças presenciais integradas ao terminal</p>
      </div>
    </div>
    <div class="pe-header-actions">
      <a class="btn btn-outline-warning" routerLink="/admin/pagamentos-eletronicos/transacoes">
        <i class="fas fa-exclamation-triangle mr-1"></i> Fila operacional
      </a>
      <button class="btn btn-outline-primary" (click)="carregue()" [disabled]="carregando">
        <i class="fas fa-sync mr-1" [ngClass]="{'fa-spin': carregando}"></i> Atualizar
      </button>
    </div>
  </header>

  <div class="alert alert-danger" *ngIf="erro"><i class="fas fa-exclamation-circle mr-2"></i>{{erro}}</div>
  <div class="alert alert-success" *ngIf="mensagemSucesso"><i class="fas fa-check-circle mr-2"></i>{{mensagemSucesso}}</div>

  <section class="pe-card pe-configuration-card">
    <div class="pe-card-heading">
      <div>
        <span class="pe-eyebrow">Operação</span>
        <h5>Status e ambiente</h5>
      </div>
      <span class="pe-status-pill" [ngClass]="diagnostico.pronto ? 'is-ready' : 'is-pending'">
        <i class="fas" [ngClass]="diagnostico.pronto ? 'fa-check-circle' : 'fa-clock'"></i>
        {{diagnostico.pronto ? 'Pronto para cobrar' : 'Configuração pendente'}}
      </span>
    </div>

    <div class="pe-config-grid">
      <div class="form-group mb-0">
        <label for="ambienteConnectTef">Ambiente</label>
        <select id="ambienteConnectTef" class="form-control" [(ngModel)]="configuracao.ambiente" name="ambiente">
          <option value="HOMOLOGACAO">Homologação</option>
          <option value="PRODUCAO">Produção</option>
        </select>
      </div>
      <div class="form-group mb-0 pe-document-field">
        <label for="documentoConnectTef">CPF/CNPJ de vinculação</label>
        <input id="documentoConnectTef" class="form-control" [(ngModel)]="configuracao.documentoVinculacao" name="documentoVinculacao">
      </div>
      <div class="pe-switches">
        <div class="pe-switch-item">
          <div>
            <strong>Integração ativa</strong>
            <span>Permite cobranças no terminal</span>
          </div>
          <div class="custom-control custom-switch">
            <input type="checkbox" class="custom-control-input" id="connecttefAtivo" [(ngModel)]="configuracao.ativo" name="ativo">
            <label class="custom-control-label" for="connecttefAtivo"><span class="sr-only">Integração ativa</span></label>
          </div>
        </div>
        <div class="pe-switch-item">
          <div>
            <strong>Conformidade Goiás</strong>
            <span>Exige pagamento integrado presencial</span>
          </div>
          <div class="custom-control custom-switch">
            <input type="checkbox" class="custom-control-input" id="modoGo" [(ngModel)]="configuracao.modoConformidadeGo" name="modoConformidadeGo">
            <label class="custom-control-label" for="modoGo"><span class="sr-only">Conformidade Goiás</span></label>
          </div>
        </div>
      </div>
    </div>

    <div class="pe-card-actions">
      <button class="btn btn-primary" (click)="salveConfiguracao()" [disabled]="salvando">
        <i class="fas fa-save mr-1"></i> Salvar configuração
      </button>
      <span class="text-muted small">As alterações valem para novas cobranças.</span>
    </div>
    <ul class="pe-error-list" *ngIf="diagnostico.erros && diagnostico.erros.length">
      <li *ngFor="let item of diagnostico.erros">{{item}}</li>
    </ul>
  </section>

  <div class="pe-operational-grid">
    <section class="pe-card pe-terminals-card">
      <div class="pe-card-heading">
        <div>
          <span class="pe-eyebrow">Dispositivos</span>
          <h5>Terminais vinculados</h5>
        </div>
        <span class="pe-count-pill">{{terminais.length}}</span>
      </div>
      <p class="pe-card-description">O terminal funciona mesmo sem os módulos Caixa e Fiscal.</p>

      <button class="btn btn-outline-primary pe-link-terminal" (click)="soliciteVinculacao()" [disabled]="vinculando">
        <i class="fas mr-1" [ngClass]="vinculando ? 'fa-spinner fa-spin' : 'fa-qrcode'"></i>
        {{vinculando ? 'Gerando QR Code...' : 'Vincular novo terminal'}}
      </button>

      <div class="pe-linking-panel" *ngIf="qrCodeImagem">
        <div class="pe-linking-instructions">
          <span class="pe-eyebrow">Vinculação em andamento</span>
          <h6>Leia o QR Code no terminal</h6>
          <ol>
            <li>No terminal ConnectTEF, acesse a opção de vinculação da automação.</li>
            <li>Leia o QR Code exibido ao lado.</li>
            <li>Aguarde o terminal aparecer como <strong>Disponível</strong> nesta tela.</li>
          </ol>
          <p><i class="fas fa-shield-alt mr-1"></i> O QR Code identifica esta empresa e deve ser usado somente no terminal que será vinculado.</p>
        </div>
        <div class="pe-linking-qr">
          <img class="qrcode" [src]="qrCodeImagem" alt="QR para vincular terminal ConnectTEF">
          <span><i class="fas fa-circle-notch fa-spin mr-1"></i> Aguardando leitura no terminal</span>
        </div>
      </div>

      <div class="pe-terminal-list" *ngIf="terminais.length">
        <div *ngFor="let terminal of terminais" class="pe-terminal-item">
          <span class="pe-terminal-icon"><i class="fas fa-credit-card"></i></span>
          <div class="pe-terminal-main">
            <div class="pe-terminal-title">
              <strong>{{terminal.numeroSerieTerminal || terminal.numeroSerieAutomacao}}</strong>
              <span class="pe-status-pill compact" [ngClass]="terminalCobravel(terminal) ? 'is-ready' : 'is-muted'">
                {{terminalCobravel(terminal) ? 'Disponível' : 'Indisponível'}}
              </span>
            </div>
            <span>{{terminal.statusVinculo === 'LINKED' ? 'Vinculado' : 'Aguardando vínculo'}} · {{rotuloModoOperacao(terminal)}} · {{terminal.ambiente === 'PRODUCAO' ? 'Produção' : 'Homologação'}}</span>
          </div>
          <button class="btn btn-sm btn-outline-danger" *ngIf="terminal.ativo" (click)="desativeTerminal(terminal)">
            Desativar
          </button>
        </div>
      </div>
      <div class="pe-empty-state" *ngIf="!terminais.length">
        <i class="fas fa-credit-card"></i>
        <span>Nenhum terminal vinculado.</span>
      </div>
    </section>

    <aside class="pe-side-stack">
      <section class="pe-card pe-billing-card">
        <span class="pe-side-icon"><i class="fas fa-receipt"></i></span>
        <div>
          <span class="pe-eyebrow">Mensalidade</span>
          <h5>Cobrança por terminal</h5>
          <strong class="pe-price">R$ 50,00</strong><span class="pe-price-suffix"> / terminal ativo</span>
          <div class="pe-billing-summary">
            <span>Terminais faturáveis <strong>{{terminaisFaturaveis.length}}</strong></span>
            <span>Estimativa mensal <strong>{{estimativaMensal | currency:'BRL'}}</strong></span>
          </div>
        </div>
        <div class="alert alert-warning mt-3 mb-0" *ngIf="configuracao.cobrancaPendente">Há uma pendência de sincronização da cobrança.</div>
      </section>

      <section class="pe-card">
        <span class="pe-eyebrow">Integrações opcionais</span>
        <h5>Comportamento adicional</h5>
        <div class="pe-capability-list">
          <div class="pe-capability-item" [class.is-enabled]="diagnostico.capacidadesOpcionais.caixa">
            <i class="fas" [ngClass]="diagnostico.capacidadesOpcionais.caixa ? 'fa-check-circle' : 'fa-minus-circle'"></i>
            <div><strong>Caixa</strong><span>{{diagnostico.capacidadesOpcionais.caixa ? 'Lançamento automático disponível' : 'Sem lançamento automático'}}</span></div>
          </div>
          <div class="pe-capability-item" [class.is-enabled]="diagnostico.capacidadesOpcionais.fiscal">
            <i class="fas" [ngClass]="diagnostico.capacidadesOpcionais.fiscal ? 'fa-check-circle' : 'fa-minus-circle'"></i>
            <div><strong>Fiscal</strong><span *ngIf="!diagnostico.capacidadesOpcionais.fiscal">Sem alteração de NF-e/NFC-e</span><span *ngIf="diagnostico.capacidadesOpcionais.fiscal">{{fiscalEnvioAutomatico ? 'Envio automático da NFC-e' : 'Envio manual pelo botão Enviar'}}</span></div>
          </div>
        </div>
      </section>
    </aside>
  </div>

  <section class="pe-card pe-mappings-card">
    <div class="pe-card-heading pe-mappings-heading">
      <div>
        <span class="pe-eyebrow">Formas aceitas</span>
        <h5>Formas de pagamento integradas</h5>
        <p>Ative somente as formas que serão cobradas presencialmente pelo ConnectTEF.</p>
      </div>
      <span class="pe-help-pill"><i class="fas fa-info-circle mr-1"></i> Somente à vista</span>
    </div>

    <div class="pe-mapping-list">
      <div class="pe-mapping-item" *ngFor="let item of mapeamentos" [class.is-inactive]="!item.ativo">
        <div class="pe-mapping-name">
          <span class="pe-method-icon"><i class="fas fa-wallet"></i></span>
          <div>
            <strong>{{item.formaDePagamento.nome || item.formaDePagamento.descricao}}</strong>
            <span>{{item.ativo ? rotuloMetodo(item.metodo) + ' presencial' : 'Não integrada ao terminal'}}</span>
          </div>
        </div>

        <div class="pe-mapping-settings" *ngIf="item.ativo">
          <div class="form-group mb-0">
            <label>Método no ConnectTEF</label>
            <select class="form-control" [(ngModel)]="item.metodo"
                    (ngModelChange)="atualizeMetodoMapeamento(item)"
                    [name]="'metodo' + item.formaDePagamento.id">
              <option *ngFor="let metodo of METODOS" [value]="metodo">{{rotuloMetodo(metodo)}}</option>
            </select>
          </div>
          <div class="pe-type-summary">
            <small>Modalidade</small>
            <strong>{{rotuloModalidade(item.metodo)}}</strong>
          </div>
        </div>

        <div class="pe-mapping-toggle">
          <span>{{item.ativo ? 'Integrada' : 'Inativa'}}</span>
          <div class="custom-control custom-switch">
            <input type="checkbox" class="custom-control-input" [id]="'ativo' + item.formaDePagamento.id"
                   [(ngModel)]="item.ativo" [name]="'ativo' + item.formaDePagamento.id">
            <label class="custom-control-label" [for]="'ativo' + item.formaDePagamento.id"><span class="sr-only">Ativar forma de pagamento</span></label>
          </div>
        </div>
      </div>
    </div>

    <div class="pe-card-actions pe-mapping-actions">
      <button class="btn btn-primary" (click)="salveMapeamentos()" [disabled]="salvando">
        <i class="fas fa-save mr-1"></i> Salvar formas integradas
      </button>
    </div>
  </section>
</div>
